export default "__VITE_ASSET__BLKPr0Y7__"